import { useQuery } from '@apollo/client'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material'
import { GET_AIRCRAFT_LIST } from './queries'
import { useState, useEffect } from 'react'

interface Aircraft {
  id: string
  tailNumber: string
  model: string
  orgSlug: string
}

interface AircraftSelectorProps {
  selectedAircraftId: string | null
  onAircraftSelect: (aircraftId: string | null, orgSlug?: string | null) => void
}

const AircraftSelector = ({
  selectedAircraftId,
  onAircraftSelect,
}: AircraftSelectorProps) => {
  // Always use orgSlug: 'all' for admin context
  const orgSlug = 'all'
  const { data, loading, error } = useQuery(GET_AIRCRAFT_LIST, {
    variables: { orgSlug },
  })
  const aircraft: Aircraft[] = data?.aircrafts || []

  const handleChange = (e) => {
    const id = e.target.value || null
    const found = aircraft.find((ac) => ac.id === id)
    onAircraftSelect(id, found?.orgSlug || null)
  }

  if (loading) {
    return <CircularProgress size={24} />
  }

  if (error) {
    return <div>Error loading aircraft: {error.message}</div>
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="aircraft-select-label">Aircraft</InputLabel>
      <Select
        labelId="aircraft-select-label"
        id="aircraft-select"
        value={selectedAircraftId || ''}
        label="Aircraft"
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>Select an aircraft</em>
        </MenuItem>
        {aircraft.map((ac) => (
          <MenuItem key={ac.id} value={ac.id}>
            {ac.tailNumber} - {ac.model}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default AircraftSelector
